// extracted by mini-css-extract-plugin
module.exports = {"radio":"RadioGroup_radio__VFn0r","option":"RadioGroup_option__cjKfW"};